var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 384.25 141.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{mask:url(#mask);filter:url(#luminosity-noclip-3);}.cls-12,.cls-2,.cls-4{mix-blend-mode:multiply;}.cls-2{fill:url(#linear-gradient);}.cls-3{mask:url(#mask-2);filter:url(#luminosity-noclip-4);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{isolation:isolate;}.cls-6{fill:#3c3c3b;}.cls-7{fill:#00a8b0;}.cls-8{mask:url(#mask-3);}.cls-12,.cls-9{opacity:0.6;}.cls-9{fill:url(#linear-gradient-3);}.cls-10{fill:#008292;}.cls-11{mask:url(#mask-4);}.cls-12{fill:url(#linear-gradient-4);}.cls-13{fill:#494645;}.cls-14{filter:url(#luminosity-noclip-2);}.cls-15{filter:url(#luminosity-noclip);}"), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 243.29,
    y: -7799.13,
    width: 50.74,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 243.29,
    y: -7799.13,
    width: 50.74,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2475.6,
    y1: 1836.41,
    x2: 2497.57,
    y2: 1842.32,
    gradientTransform: "matrix(-0.17, -0.98, -0.98, 0.17, 2512.89, 2158.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 272.33,
    y: -7799.13,
    width: 22.46,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 272.33,
    y: -7799.13,
    width: 22.46,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 429.91,
    y1: 43.53,
    x2: 451.88,
    y2: 49.45,
    gradientTransform: "translate(-157.8 -6.3)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-3",
    x: 243.29,
    y: 13.66,
    width: 50.74,
    height: 25.86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 243.29,
    y: 13.66,
    width: 50.74,
    height: 25.86,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M294,13.66,272.34,39.52h-29S265,13.67,294,13.66Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 2475.6,
    y1: 1836.41,
    x2: 2497.57,
    y2: 1842.32,
    gradientTransform: "matrix(-0.17, -0.98, -0.98, 0.17, 2512.89, 2158.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-4",
    x: 272.33,
    y: 13.67,
    width: 22.46,
    height: 54.45,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    x: 272.33,
    y: 13.67,
    width: 22.46,
    height: 54.45,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M294,13.67l-21.7,25.85,5,28.6S299.06,42.24,294,13.67Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 429.91,
    y1: 43.53,
    x2: 451.88,
    y2: 49.45,
    gradientTransform: "translate(-157.8 -6.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d1d1b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M15,102,45.05,50.48,61.15,102H53.2L49.63,90.29H30.16L23.31,102Zm18.5-18.31H47.75s-4.21-16.83-4.44-18.41C42.78,66.45,33.46,83.69,33.46,83.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M136.86,102l7.89-51.52s27.81,36.24,28.41,37.23c0-1,5.19-35.27,5.19-35.27h6.77L177.22,104s-28-36.39-28.46-37.27c-.09,1.54-5.14,35.34-5.14,35.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M224.45,102l8.12-49.55h29.05l-1.12,7H239.05l-2,12.45h21.39l-1.11,6.94H235.84l-2.59,16h21.46L253.49,102Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M85,102,115.06,50.5,131.16,102h-8l-3.57-11.71H100.17L93.32,102Zm18.5-18.31h14.29s-4.2-16.83-4.44-18.42C112.79,66.47,103.47,83.71,103.47,83.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M56.24,50.5h7.65S74.63,84.36,74.71,85.09c.56-1.27,20.06-34.59,20.06-34.59H103L72.29,102Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "272.33 39.53 294.04 13.66 265.01 13.66 243.29 39.53 272.33 39.53"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M294,13.66,272.34,39.52h-29S265,13.67,294,13.66Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "272.32 39.53 294.03 13.66 299.07 42.25 277.37 68.12 272.32 39.53"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M294,13.67l-21.7,25.85,5,28.6S299.06,42.24,294,13.67Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M209.31,74.53c-.54-.35-1.35-.81-2.41-1.38-4.26-2.36-6.35-4.92-6.26-7.65a7.64,7.64,0,0,1,2.46-5.59,8.47,8.47,0,0,1,6-2.15,7.74,7.74,0,0,1,4.47,1.34,17,17,0,0,1,3.94,5L222,58.75a14.32,14.32,0,0,0-5.46-5.61,15.85,15.85,0,0,0-7.91-1.88,15.37,15.37,0,0,0-11.09,4.15A15.09,15.09,0,0,0,193,66.18a13.41,13.41,0,0,0,.54,4.37,9.67,9.67,0,0,0,2,3.56q1.84,2.16,7.28,5.27,1.29.75,1.95,1.17a13.52,13.52,0,0,1,4.38,3.74,7.35,7.35,0,0,1,1.14,4.46,8.34,8.34,0,0,1-2.64,6.06,9.09,9.09,0,0,1-6.43,2.33,8.33,8.33,0,0,1-5.4-1.84,16,16,0,0,1-4.12-5.87l-5,5.93a15.2,15.2,0,0,0,5.06,6,15.6,15.6,0,0,0,8.91,2.46q7.77,0,12.43-4.19T218,88.38a13.62,13.62,0,0,0-1.81-7.75A19.93,19.93,0,0,0,209.31,74.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M15,127l6.64-11.5L25.07,127H24L23,123.32H18.1L16,127Zm7.75-4.5-1.4-4.91L18.6,122.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M31.65,124.33a4,4,0,0,0,1.15,1.55,2.42,2.42,0,0,0,1.54.51,2.23,2.23,0,0,0,1.68-.65,2.37,2.37,0,0,0,.63-1.72,2.1,2.1,0,0,0-.36-1.27,4.51,4.51,0,0,0-1.52-1.1,6.15,6.15,0,0,1-2-1.49,2.88,2.88,0,0,1-.47-1.69,2.83,2.83,0,0,1,.88-2.13,3.24,3.24,0,0,1,2.28-.82,2.93,2.93,0,0,1,1.58.4,3.54,3.54,0,0,1,1.23,1.26l-.64.57a3,3,0,0,0-1-1,2.39,2.39,0,0,0-2.83.25,2,2,0,0,0-.63,1.52,1.85,1.85,0,0,0,.36,1.17,5.34,5.34,0,0,0,1.64,1.16,5.78,5.78,0,0,1,2,1.48,2.88,2.88,0,0,1,.48,1.71,3.21,3.21,0,0,1-.92,2.37,3.27,3.27,0,0,1-2.4.91,3.36,3.36,0,0,1-2-.57A4,4,0,0,1,31,125Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M46.22,127h-1l1.47-11.23h1.61a9.33,9.33,0,0,1,2,.14,2.82,2.82,0,0,1,1,.48,2.63,2.63,0,0,1,.73.93,2.9,2.9,0,0,1,.26,1.22,3.52,3.52,0,0,1-.29,1.46,2.83,2.83,0,0,1-.88,1.07,2.89,2.89,0,0,1-1.15.52,9.55,9.55,0,0,1-2.1.16h-1Zm2-10.36h-.63L47,120.91h1.18a8,8,0,0,0,1.26-.06,2.86,2.86,0,0,0,.73-.21,2.06,2.06,0,0,0,.87-.81,2.4,2.4,0,0,0,.31-1.24,2.08,2.08,0,0,0-.22-1,1.62,1.62,0,0,0-.62-.65,2,2,0,0,0-.65-.24,6,6,0,0,0-1.09-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M59.06,127l1.5-11.23h1L60,127Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M69.62,127h-1l1.47-11.23h1.61a9.27,9.27,0,0,1,2,.14,2.79,2.79,0,0,1,1,.48,2.74,2.74,0,0,1,.73.93,2.9,2.9,0,0,1,.25,1.22,3,3,0,0,1-1,2.36,4,4,0,0,1-2.68.85L75.59,127H74.48l-3.43-5.25h-.74Zm2-10.36H71l-.57,4.27H71.6a8.17,8.17,0,0,0,1.26-.06,2.9,2.9,0,0,0,.72-.21,2,2,0,0,0,.87-.81,2.41,2.41,0,0,0,.32-1.24,2.21,2.21,0,0,0-.22-1,1.69,1.69,0,0,0-.62-.65,2.06,2.06,0,0,0-.66-.24,5.87,5.87,0,0,0-1.08-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M82.8,127l1.47-11.23h5.54l-.11.86H85.12l-.48,3.68h4.45l-.11.84H84.52l-.64,5h4.69l-.13.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M109.48,127.39l-2.66-11.62h1l2,8.81,3.89-9.14,2.08,9.16,3.81-8.83h1l-5.09,11.62-2.08-9.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M126.93,127l1.5-11.23h1L127.91,127Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M138.42,127l1.37-10.34h-3.23l.13-.89h7.13l-.12.89h-2.95L139.39,127Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M150,127l1.47-11.23h1l-.61,4.63H158l.62-4.63h1L158.09,127h-1l.75-5.77h-6.17L151,127Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M173.17,115.52a5.56,5.56,0,0,1,4.06,1.48,5.3,5.3,0,0,1,1.52,4,6.47,6.47,0,0,1-.49,2.52,6,6,0,0,1-1.41,2.06,6.08,6.08,0,0,1-2,1.28,6.86,6.86,0,0,1-2.48.45,5.18,5.18,0,0,1-5.45-5.48,6.87,6.87,0,0,1,.48-2.57,5.88,5.88,0,0,1,1.38-2.06,6,6,0,0,1,2-1.25A7.07,7.07,0,0,1,173.17,115.52Zm4.56,5.44a4.36,4.36,0,0,0-4.59-4.6,5.07,5.07,0,0,0-2,.39,4.71,4.71,0,0,0-1.65,1.09,5.29,5.29,0,0,0-1.2,1.83,5.7,5.7,0,0,0-.42,2.17,4.49,4.49,0,0,0,1.26,3.32,4.45,4.45,0,0,0,3.3,1.26,5.39,5.39,0,0,0,2-.38,5.13,5.13,0,0,0,1.68-1.11,5.5,5.5,0,0,0,1.18-1.81A5.69,5.69,0,0,0,177.73,121Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M188.38,115.77l-.92,6.91-.06.54c0,.18,0,.36,0,.52a2.76,2.76,0,0,0,.69,2,2.64,2.64,0,0,0,1.95.71,3.76,3.76,0,0,0,1.59-.32,2.78,2.78,0,0,0,1.14-1,7.13,7.13,0,0,0,.91-3.1c0-.13,0-.23,0-.28l.79-6h1l-.84,6.31c0,.1,0,.25-.05.44a7,7,0,0,1-1,3.2,3.84,3.84,0,0,1-1.52,1.2,5.21,5.21,0,0,1-2.1.41,3.67,3.67,0,0,1-2.61-.87,3.2,3.2,0,0,1-.93-2.46c0-.26,0-.59,0-1s.1-.89.19-1.53l.75-5.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M204.39,127l1.37-10.34h-3.23l.12-.89h7.14l-.11.89h-3L205.37,127Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M226.21,127l1.48-11.23h1.76a7.8,7.8,0,0,1,1.81.15,2,2,0,0,1,.94.49,2.45,2.45,0,0,1,.61.87,2.82,2.82,0,0,1,.22,1.11,2.75,2.75,0,0,1-.48,1.67,2.46,2.46,0,0,1-1.39.91,2.8,2.8,0,0,1,1.51,1,2.84,2.84,0,0,1,.51,1.73,3.3,3.3,0,0,1-.37,1.51,3,3,0,0,1-1,1.16,3.22,3.22,0,0,1-1.25.51A16.4,16.4,0,0,1,228,127Zm1.07-.88h1.39a11.57,11.57,0,0,0,1.41-.07,3.36,3.36,0,0,0,.81-.25,1.92,1.92,0,0,0,.92-.86,2.6,2.6,0,0,0,.34-1.35,2.31,2.31,0,0,0-.23-1.07,1.75,1.75,0,0,0-.68-.72,2,2,0,0,0-.78-.27,12.57,12.57,0,0,0-1.72-.08h-.85Zm.72-5.52h1a9.66,9.66,0,0,0,1.27-.06,2.68,2.68,0,0,0,.72-.2,1.79,1.79,0,0,0,.77-.75,2.28,2.28,0,0,0,.29-1.17,1.9,1.9,0,0,0-.2-.88,1.65,1.65,0,0,0-.57-.63,1.55,1.55,0,0,0-.59-.23,5.68,5.68,0,0,0-1.08-.07h-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M247,115.52a5.57,5.57,0,0,1,4.06,1.48,5.34,5.34,0,0,1,1.52,4,6.65,6.65,0,0,1-.49,2.52,5.9,5.9,0,0,1-1.42,2.06,6.14,6.14,0,0,1-2,1.28,6.86,6.86,0,0,1-2.48.45,5.2,5.2,0,0,1-5.46-5.48,6.68,6.68,0,0,1,.49-2.57,5.75,5.75,0,0,1,1.38-2.06,6,6,0,0,1,2-1.25A7.17,7.17,0,0,1,247,115.52Zm4.55,5.44a4.35,4.35,0,0,0-4.59-4.6,5.14,5.14,0,0,0-2,.39,4.89,4.89,0,0,0-1.65,1.09,5.59,5.59,0,0,0-1.2,1.83,5.89,5.89,0,0,0-.41,2.17,4.53,4.53,0,0,0,1.25,3.32,4.46,4.46,0,0,0,3.3,1.26,5.4,5.4,0,0,0,2-.38,5.08,5.08,0,0,0,1.67-1.11,5.53,5.53,0,0,0,1.19-1.81A5.68,5.68,0,0,0,251.57,121Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M262.22,115.77l-.91,6.91q0,.28-.06.54c0,.18,0,.36,0,.52a2.72,2.72,0,0,0,.7,2,2.61,2.61,0,0,0,1.95.71,3.79,3.79,0,0,0,1.59-.32,2.84,2.84,0,0,0,1.14-1,7.27,7.27,0,0,0,.91-3.1c0-.13,0-.23,0-.28l.79-6h1l-.84,6.31c0,.1,0,.25-.06.44a6.87,6.87,0,0,1-1,3.2,3.77,3.77,0,0,1-1.52,1.2,5.21,5.21,0,0,1-2.1.41,3.63,3.63,0,0,1-2.6-.87,3.2,3.2,0,0,1-.94-2.46,9.26,9.26,0,0,1,.06-1c0-.38.1-.89.18-1.53l.75-5.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M276.34,127l1.53-11.53,6.73,9.39,1.2-9.09h.93L285.2,127.3l-6.72-9.38L277.29,127Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M293.82,127l1.48-11.23h1.49a13,13,0,0,1,2.89.22,4.38,4.38,0,0,1,1.57.75,4.48,4.48,0,0,1,1.42,1.79,6,6,0,0,1,.49,2.48,6.81,6.81,0,0,1-.37,2.28,6,6,0,0,1-1.08,1.87,6.11,6.11,0,0,1-1.14,1,5.24,5.24,0,0,1-1.37.6,8.13,8.13,0,0,1-1.05.21,13.12,13.12,0,0,1-1.37.06h-3Zm1.08-.83h.7a16.33,16.33,0,0,0,3.09-.21,4.28,4.28,0,0,0,1.56-.7,4.62,4.62,0,0,0,1.38-1.8,5.92,5.92,0,0,0,.49-2.45,5.23,5.23,0,0,0-.39-2.07,3.88,3.88,0,0,0-1.14-1.51,3.55,3.55,0,0,0-1.34-.64,10.13,10.13,0,0,0-2.32-.2h-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M308.4,127,315,115.5,318.5,127h-1.05l-1.07-3.68h-4.84L309.46,127Zm7.75-4.5-1.4-4.91L312,122.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M326,127h-1l1.48-11.23h1.6a9.27,9.27,0,0,1,2,.14,2.55,2.55,0,0,1,1.76,1.41,2.9,2.9,0,0,1,.26,1.22,3,3,0,0,1-1,2.36,4,4,0,0,1-2.67.85L332,127h-1.12l-3.43-5.25h-.74Zm2-10.36h-.62l-.57,4.27H328a8.09,8.09,0,0,0,1.26-.06,2.9,2.9,0,0,0,.72-.21,2,2,0,0,0,.87-.81,2.4,2.4,0,0,0,.31-1.24,2.21,2.21,0,0,0-.21-1,1.62,1.62,0,0,0-.62-.65,2,2,0,0,0-.66-.24,5.87,5.87,0,0,0-1.08-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M339.19,127l1.5-11.23h1L340.16,127Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M348.79,127l1.47-11.23h5.54l-.11.86h-4.58l-.48,3.68h4.45l-.11.84h-4.46l-.64,5h4.69l-.13.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M362.68,124.33a4,4,0,0,0,1.15,1.55,2.44,2.44,0,0,0,1.54.51,2.25,2.25,0,0,0,1.69-.65,2.36,2.36,0,0,0,.62-1.72,2.1,2.1,0,0,0-.36-1.27,4.4,4.4,0,0,0-1.52-1.1,6.19,6.19,0,0,1-2-1.49,3.08,3.08,0,0,1,.41-3.82,3.21,3.21,0,0,1,2.28-.82,3,3,0,0,1,1.58.4,3.62,3.62,0,0,1,1.23,1.26l-.65.57a3,3,0,0,0-1-1,2.38,2.38,0,0,0-2.82.25,2,2,0,0,0-.63,1.52,1.91,1.91,0,0,0,.35,1.17,5.34,5.34,0,0,0,1.64,1.16,5.74,5.74,0,0,1,2,1.48,2.88,2.88,0,0,1,.47,1.71,3.17,3.17,0,0,1-.92,2.37,3.24,3.24,0,0,1-2.4.91,3.39,3.39,0,0,1-2-.57A4.16,4.16,0,0,1,362,125Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "275.65 86.71 277.5 76.25 283.06 76.25 282.84 77.64 278.66 77.64 278.42 80.43 282.6 80.43 282.37 81.83 277.96 81.83 277.27 86.71 275.65 86.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "284.92 86.71 286.54 76.25 288.16 76.25 286.54 86.71 284.92 86.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M290.25,86.71l1.85-10.93,5.34,6.51c.23.24.47.47.47.7.23.23.45.47.45.7a.84.84,0,0,1,.24-.7v-.93l.93-5.81h1.61l-1.85,10.92L294,80.66a3.28,3.28,0,0,0-.69-.93c0-.23-.24-.23-.24-.47a8.5,8.5,0,0,0-.23,1.4v.24l-.92,5.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M301.85,86.71l6.48-10.93,3.26,10.93H310l-.7-2.56h-4.17l-1.39,2.56Zm3.94-3.95h3l-.69-2.57v-.46a.84.84,0,0,1-.24-.7c0,.23-.22.47-.22.7l-.47.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M313.67,86.71l1.63-10.93,5.56,6.51c.23.24.23.47.46.7s.24.47.47.7V83a1.79,1.79,0,0,1,.23-.93l.93-5.81h1.4l-1.64,10.92-5.56-6.51c-.23-.47-.23-.7-.46-.93s-.24-.23-.46-.47a4,4,0,0,1-.24,1.4v.24l-.93,5.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M335.7,76.94l-.24,1.86a6.16,6.16,0,0,0-1.38-1.16c-.47,0-.93-.23-1.39-.23-.7,0-1.17.23-1.63.23a2.29,2.29,0,0,0-1.16.93,4.16,4.16,0,0,0-1.15,1.62,3.41,3.41,0,0,0-.24,1.64,3.21,3.21,0,0,0,.93,2.56,2.86,2.86,0,0,0,2.32,1.16c.7,0,1.16-.24,1.63-.24a5,5,0,0,0,1.39-.92l-.47,2.09c-.46.23-.92.23-1.39.46h-1.16a4.88,4.88,0,0,1-3.71-1.39,4.8,4.8,0,0,1-1.16-3.72,8.3,8.3,0,0,1,.46-2.33,5.44,5.44,0,0,1,1.4-1.86,3.45,3.45,0,0,1,1.62-1.16,3.76,3.76,0,0,1,2.32-.47,3.81,3.81,0,0,1,1.62.24,1.42,1.42,0,0,1,1.39.69Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "337.56 86.71 339.41 76.25 341.04 76.25 339.18 86.71 337.56 86.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M341.73,86.71l6.49-10.93,3.25,10.93h-1.63l-.69-2.56H345l-1.39,2.56Zm3.95-3.95h3l-.7-2.57v-.46a.87.87,0,0,1-.23-.7c0,.23-.23.47-.23.7l-.46.46Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "353.55 86.71 355.18 76.25 356.8 76.25 355.41 85.08 359.35 85.08 358.89 86.71 353.55 86.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M273.79,100.43,275,99.5a4.86,4.86,0,0,0,.7,1.17c.46.23.69.46,1.15.46a2,2,0,0,0,1.4-.46c.46-.47.46-.7.46-1.4a1.4,1.4,0,0,0-.24-.94c0-.22-.46-.46-.92-.69l-.23-.24a5.48,5.48,0,0,1-1.62-1.16c-.24-.23-.24-.46-.47-.69v-.93a3,3,0,0,1,.93-2.33,3.92,3.92,0,0,1,2.31-.69,3.5,3.5,0,0,1,1.63.23A2.71,2.71,0,0,1,281.21,93l-.93.93c-.23-.23-.47-.7-.93-.7a1.2,1.2,0,0,0-.93-.46,1.76,1.76,0,0,0-1.15.46c-.23.47-.47.7-.47,1.16,0,.7.47,1.17,1.16,1.63a.87.87,0,0,0,.7.23,4.07,4.07,0,0,1,1.39,1.4,1.9,1.9,0,0,1,.23,1.63,2.7,2.7,0,0,1-.93,2.33,3.49,3.49,0,0,1-2.55.92,4.38,4.38,0,0,1-1.85-.46,4,4,0,0,1-1.16-1.63Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "283.3 102.29 284.92 91.83 290.71 91.83 290.49 93.22 286.31 93.22 285.85 95.78 290.03 95.78 289.79 97.4 285.61 97.4 285.15 100.67 289.32 100.67 289.1 102.29 283.3 102.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M294.19,102.29h-1.63l1.63-10.46h3.72c.23.23.69.23.92.46s.46.7.7.93c0,.47.22.93.22,1.4a4.23,4.23,0,0,1-.92,2.09,2.9,2.9,0,0,1-1.85.93l2.55,4.65h-1.62l-2.79-4.65h-.23Zm.93-5.82h.23a4.65,4.65,0,0,0,2.09-.46,1.4,1.4,0,0,0,.7-1.39,1.77,1.77,0,0,0-.47-1.17c-.23-.23-.93-.23-1.85-.23h-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M302.07,91.83h1.63l1.39,6.28c0,.22.23.46.23.7v.46c.23-.23.23-.46.47-.7a.87.87,0,0,1,.23-.7l3.48-6h1.86l-6.5,10.69Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "312.05 102.29 313.67 91.83 315.3 91.83 313.67 102.29 312.05 102.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M326.66,92.52l-.24,1.63a4.76,4.76,0,0,0-1.39-.93,3,3,0,0,0-1.39-.23,3.47,3.47,0,0,0-1.62.23,4.9,4.9,0,0,0-1.39.93c-.23.47-.7.93-.93,1.4-.23.69-.23,1.16-.47,1.85a4.89,4.89,0,0,0,.94,2.57,3.68,3.68,0,0,0,2.54,1.16,3.26,3.26,0,0,0,1.39-.46,3.43,3.43,0,0,0,1.63-.7l-.46,1.86a3.26,3.26,0,0,1-1.39.46,3,3,0,0,1-1.39.23,4.69,4.69,0,0,1-3.48-1.39,4.12,4.12,0,0,1-1.17-3.73,3.78,3.78,0,0,1,.47-2.32A6.14,6.14,0,0,1,319.47,93a8,8,0,0,1,1.85-1.16,6.49,6.49,0,0,1,2.09-.23,4.58,4.58,0,0,1,1.86.23,2,2,0,0,1,1.39.69Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "328.51 102.29 330.13 91.83 335.93 91.83 335.7 93.22 331.52 93.22 331.06 95.78 335.24 95.78 335 97.4 330.83 97.4 330.37 100.67 334.54 100.67 334.31 102.29 328.51 102.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M337.32,100.43l1.17-.93a4.87,4.87,0,0,0,.69,1.17c.46.23.7.46,1.16.46a2,2,0,0,0,1.39-.46c.46-.47.46-.7.46-1.4a1.5,1.5,0,0,0-.22-.94c0-.22-.47-.46-.93-.69l-.24-.24a5.79,5.79,0,0,1-1.62-1.16c-.23-.23-.23-.46-.47-.69v-.93a3,3,0,0,1,.93-2.33A4,4,0,0,1,342,91.6a3.45,3.45,0,0,1,1.61.23A2.84,2.84,0,0,1,344.75,93l-.93.93c-.24-.23-.46-.7-.93-.7a1.21,1.21,0,0,0-.92-.46,1.81,1.81,0,0,0-1.17.46c-.23.47-.46.7-.46,1.16,0,.7.46,1.17,1.16,1.63a.86.86,0,0,0,.69.23,3.81,3.81,0,0,1,1.39,1.4,1.93,1.93,0,0,1,.24,1.63,2.73,2.73,0,0,1-.93,2.33,3.51,3.51,0,0,1-2.55.92,4.34,4.34,0,0,1-1.85-.46,4.17,4.17,0,0,1-1.17-1.63Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c55c010fd23b3e09930bca4d81723604.svg";
export { ForwardRef as ReactComponent };